export enum ESentimentAnalysisCategoryStringValue {
  TechnicalIssues = 'Technical Issues',
  NavigationComplaints = 'Navigation Complaints',
  AdExperience = 'Ad Experience',
  SupportRequests = 'Support Requests',
  BrandSentiments = 'Brand Sentiments',
  StoreComplaints = 'Store Complaints',
}

export type SENTIMENT_ANALYSIS_OPTION = {
  value: string;
  label: ESentimentAnalysisCategoryStringValue;
};

export type SENTIMENT_ANALYSIS_SUBCATEGORIES = {
  value: string;
  label: ESentimentAnalysisSubcategoryStringValue;
};

export type FeedbackItem = {
  id: string;
  title: string;
  url: string;
  imageUrl: string | null;
  label: string | null;
  category: number;
  subCategory: number;
  sentiment: number;
  isSubmitted: boolean;
  categoryDescription: string;
  subCategoryDescription: string;
  companyId: string;
  createdAt: string;
  updatedAt: string;
};

export type FeedbackItemStringified = Omit<
  FeedbackItem,
  'category' | 'subCategory' | 'sentiment'
> & {
  category: string;
  subCategory: string;
  sentiment: string;
};

export enum ESentimentAnalysisSubcategory {
  StreamingQualityAndValue,
  PlaybackIssue,
  SmartTVPlaybackError,
  PictureInPicture,
  StreamingAndDownloading,
  PlatformComparison,
  BrowserCompatibility,
  ContentBlocking,
  SubtitleSynchronization,
  AppFunctionality,
  AppPerformance,
  AppWebsiteFunctionality,
  InterfaceUsability,
  UIUXDesign,
  AutoLogout,
  Login,
  ConnectionIssue,
  Authentication,
  LimitedLibrary,
  ContentAvailability,
  PremiumRestrictions,
  AdTier,
  ValueForMoney,
  ShippingDelaysAndImportFees,
  HiddenImportFees,
  BackorderFulfillment,
  BillingIssue,
  AccountSecurity,
  CustomerSupport,
  IssueHandlingExperience,
  ViewerTrust,
  ReviewPlatform,
  ConsumerReview,
  SubscriptionTierFeatures,
  LibraryAccess,
  DeviceLimitError,
  LackOfOptions,
  LackOfOfficialLinuxApp,
  AnimePiracyAndDMCA,
  CompanyDecisions,
  LogoSimilarity,
  GamingPromotion,
  Accessibility,
}

export enum ESentimentAnalysisSubcategoryStringValue {
  StreamingQualityAndValue = 'Streaming Quality And Value',
  PlaybackIssue = 'Playback Issue',
  SmartTVPlaybackError = 'Smart TV Playback Error',
  PictureInPicture = 'Picture In Picture',
  StreamingAndDownloading = 'Streaming And Downloading',
  PlatformComparison = 'Platform Comparison',
  BrowserCompatibility = 'Browser Compatibility',
  ContentBlocking = 'Content Blocking',
  SubtitleSynchronization = 'Subtitle Synchronization',
  AppFunctionality = 'App Functionality',
  AppPerformance = 'App Performance',
  AppWebsiteFunctionality = 'App Website Functionality',
  InterfaceUsability = 'Interface Usability',
  UIUXDesign = 'UI UX Design',
  AutoLogout = 'Auto Logout',
  Login = 'Login',
  ConnectionIssue = 'Connection Issue',
  Authentication = 'Authentication',
  LimitedLibrary = 'Limited Library',
  ContentAvailability = 'Content Availability',
  PremiumRestrictions = 'Premium Restrictions',
  AdTier = 'Ad Tier',
  ValueForMoney = 'Value For Money',
  ShippingDelaysAndImportFees = 'Shipping Delays And Import Fees',
  HiddenImportFees = 'Hidden Import Fees',
  BackorderFulfillment = 'Backorder Fulfillment',
  BillingIssue = 'Billing Issue',
  AccountSecurity = 'Account Security',
  CustomerSupport = 'Customer Support',
  IssueHandlingExperience = 'Issue Handling Experience',
  ViewerTrust = 'Viewer Trust',
  ReviewPlatform = 'Review Platform',
  ConsumerReview = 'Consumer Review',
  SubscriptionTierFeatures = 'Subscription Tier Features',
  LibraryAccess = 'Library Access',
  DeviceLimitError = 'Device Limit Error',
  LackOfOptions = 'Lack Of Options',
  LackOfOfficialLinuxApp = 'Lack Of Official Linux App',
  AnimePiracyAndDMCA = 'Anime Piracy And DMCA',
  CompanyDecisions = 'Company Decisions',
  LogoSimilarity = 'Logo Similarity',
  GamingPromotion = 'Gaming Promotion',
  Accessibility = 'Accessibility',
}

export type CreateSentimentPayload = {
  id: string;
  title: string;
  url: string;
  imageUrl: string | null;
  label: string | null;
  category: number;
  subCategory: number;
  sentiment: number;
  isSubmitted: boolean;
  categoryDescription: string;
  subCategoryDescription: string;
};

export type UpdateSentimentPayload = {
  title: string;
  url: string;
  label: string;
  category: string;
  subCategory: string;
  sentiment: string;
  isSubmitted: boolean;
  categoryDescription: string;
  subCategoryDescription: string;
  uuids: string[];
  emailBody: string;
  imageUrl: string;
};
